import { render, staticRenderFns } from "./forbiddenPage.vue?vue&type=template&id=5b6d2c2c&scoped=true"
import script from "./forbiddenPage.vue?vue&type=script&lang=js"
export * from "./forbiddenPage.vue?vue&type=script&lang=js"
import style0 from "./forbiddenPage.vue?vue&type=style&index=0&id=5b6d2c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d2c2c",
  null
  
)

export default component.exports